import * as React from 'react'
import styled from 'styled-components'

import Icon from '../../../../components/ui/Icon/Icon'

import Loader from '../../../../assets/img/loader.gif'
import MoreHeaderParticles from '../../../../assets/img/more-header-particles.svg'

import * as LoyaltyApiService from '../../../../services/api/requests/Loyalty'

import { MAIN } from '../../../../services/data/profilePages.json'
import dateFormat from '../../../../services/data/dateFormat'
import numberFormat from '../../../../services/data/numberFormat'
import { setGAEvent } from '../../../../services/analytics/google-analytics'

const MainPage = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

const Header = styled.div`
  position: relative;
  display: flex;
  flex: 0 0 auto;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  min-height: 87px;
  font-size: 0.7rem;
  background: var(--color-primary);

  &::before {
    content: ' ';
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: url('${MoreHeaderParticles}');
    background-repeat: no-repeat;
    background-position: right top;
  }
`

const ReturnIcon = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 2rem;
  cursor: pointer;
  font-size: 0.92rem;
  margin-left: 20px !important;
  margin-right: 20px !important;
  color: var(--color-fg-light);
  background: rgba(255, 255, 255, 0.5);
  z-index: 1;

  & > svg {
    position: relative;
    color: #ffffff;
  }
`

const Title = styled.h1`
  flex: 1;
  padding: 20px 0;
  margin: 0;
  margin-right: 60px;
  color: #ffffff;
  font-size: 1.125rem;
  font-weight: var(--font-weight-boldest);
  text-transform: uppercase;
  text-align: center;
`

const Content = styled.div`
  padding: 0;
  overflow: auto;
`

const TabWrapper = styled.div`
  width: 100%;
  display: flex;
  border-bottom: 1px solid var(--color-fg-lighter);
`

const Tab = styled.a`
  padding: 1rem;
  cursor: pointer;
  flex: 1;
  text-align: center;
  font-size: 0.875rem;
  font-weight: var(--font-weight-bold);
  color: #ffffff;
  letter-spacing: 1px;
  text-transform: uppercase;
  opacity: ${props => (props.active ? '1' : '0.5')};
  border-bottom: 4px solid
    ${props => (props.active ? '#ffffff' : 'transparent')};

  &:hover {
    color: #ffffff;
    opacity: 0.8;
  }
`

const ListItem = styled.div`
  padding: 2rem;
  display: flex;
  border-bottom: 1px solid var(--color-fg-lighter);
`

const DetailWrapper = styled.div`
  flex: 1;
  min-width: 0;
`

const ListTitle = styled.h3`
  color: var(--color-primary);
  font-size: 0.875rem;
  font-weight: var(--font-weight-bold);
  letter-spacing: var(--letter-spacing-narrow);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin: 0;
  margin-right: 1rem;
`

const ItemDescription = styled.p`
  color: var(--color-fg-light);
  font-size: 0.75rem;
  font-weight: var(--font-weight-bold);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin: 0;
`

const Points = styled.span`
  color: var(--color-primary);
  font-size: 1rem;
  font-weight: var(--font-weight-bold);
  letter-spacing: var(--letter-spacing-narrow);
`

const BlankContainer = styled.div`
  padding: 2rem;
  text-align: center;
  ${({ smaller }) => (smaller ? `font-size: 0.95rem;` : '')}
`

const StyledLoader = styled.img.attrs({ src: Loader })`
  max-height: 30px;
`

const DEFAULT_TAB = 'earned'

class PointsHistoryPage extends React.Component {
  state = {
    currentTab: DEFAULT_TAB,
    earnedTabloadingStatus: null,
    redeemedTabloadingStatus: null,
  }

  componentDidMount() {
    this.setCurrentTab(DEFAULT_TAB)

    setGAEvent('rewards', 'view_history', 'rewards_point_history')
  }

  setCurrentTab = async tab => {
    this.setState({
      currentTab: tab,
    })

    if (tab === 'earned') {
      await this.getTransactionsEarned()
    } else if (tab === 'redeemed') {
      await this.getTransactionsRedeemed()
    }
  }

  getTransactionsEarned = async () => {
    this.setState({
      earnedTabloadingStatus: 0,
    })

    const { accessToken, setTransactionsEarned } = this.props

    try {
      const earnedResponse = await LoyaltyApiService.getTransactionsEarned(
        accessToken,
      )
      setTransactionsEarned(earnedResponse.data)
    } catch (e) {
      this.setState({
        earnedTabloadingStatus: 4,
      })
    }

    this.setState({
      earnedTabloadingStatus: 1,
    })
  }

  getTransactionsRedeemed = async () => {
    this.setState({
      redeemedTabloadingStatus: 0,
    })

    const { accessToken, setTransactionsRedeemed } = this.props

    try {
      const redeemedResponse = await LoyaltyApiService.getTransactionsRedeemed(
        accessToken,
      )
      setTransactionsRedeemed(redeemedResponse.data)
    } catch (e) {
      this.setState({
        redeemedTabloadingStatus: 4,
      })
    }

    this.setState({
      redeemedTabloadingStatus: 1,
    })
  }

  render() {
    const {
      currentTab,
      earnedTabloadingStatus,
      redeemedTabloadingStatus,
    } = this.state
    const {
      setProfileModalPage,
      transactionsEarned,
      transactionsRedeemed,
    } = this.props

    const TabContent = ({ tabData, tabLoading }) => (
      <>
        {tabLoading === 0 && (
          <BlankContainer>
            <StyledLoader />
          </BlankContainer>
        )}
        {tabLoading === 1 &&
          tabData.map(props => (
            <ListItem key={props.id}>
              <DetailWrapper>
                <ListTitle>{props.title}</ListTitle>
                <ItemDescription>
                  {dateFormat(props.date, false)}
                </ItemDescription>
                <ItemDescription>{props.description}</ItemDescription>
              </DetailWrapper>
              <Points>
                {props.points > 0 ? '+ ' : ''}
                {numberFormat(props.points)}
              </Points>
            </ListItem>
          ))}
        {tabLoading === 1 && tabData.length === 0 && (
          <BlankContainer>No Records Found</BlankContainer>
        )}
        {tabLoading === 1 && tabData.length !== 0 && (
          <BlankContainer smaller>
            All available transactions loaded. <br />
            Viewable transactions are limited to 1 year.
          </BlankContainer>
        )}
        {tabLoading === 4 && (
          <BlankContainer>Unable to Retrieve Data</BlankContainer>
        )}
      </>
    )

    return (
      <MainPage>
        <Header>
          <ReturnIcon onClick={() => setProfileModalPage(MAIN)}>
            <Icon name="slide-left" />
          </ReturnIcon>
          <Title>Points History</Title>
          <TabWrapper>
            <Tab
              active={currentTab === 'earned'}
              onClick={() => {
                this.setCurrentTab('earned')
              }}
            >
              Earned Points
            </Tab>
            <Tab
              active={currentTab === 'redeemed'}
              onClick={() => {
                this.setCurrentTab('redeemed')
              }}
            >
              Redeemed Points
            </Tab>
          </TabWrapper>
        </Header>
        <Content>
          {currentTab === 'earned' && (
            <TabContent
              tabData={transactionsEarned}
              tabLoading={earnedTabloadingStatus}
            />
          )}
          {currentTab === 'redeemed' && (
            <TabContent
              tabData={transactionsRedeemed}
              tabLoading={redeemedTabloadingStatus}
            />
          )}
        </Content>
      </MainPage>
    )
  }
}

PointsHistoryPage.defaultProps = {}

PointsHistoryPage.propTypes = {}

export default PointsHistoryPage
